<template>
  <div class="agreement-box">
    <van-tabs v-model="activeName" @click="onClick">
      <van-tab v-for="(item, index) in tabs" :title="item.title" :key="index" :name="item.name">
        <div v-if="content">
          <div class="content" :class="content.content ? 'yes' : 'no'" v-html="content.content || '暂无内容'"></div>
        </div>
        <div v-else class="empty">
          <van-empty image="error" description="暂无协议" />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import * as util from "@/utils/network";
export default {
  data() {
    return {
      tabs: [], // tabs内容
      agreementType: null, // 当前协议类型
      activeName: 0, // 选中的tabs
      activeNameIndex: 0,
      content: null, // 展示协议
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 点击切换协议内容
    onClick(name) {
      if (this.activeNameIndex == name) return;
      this.activeNameIndex = name;
      let newdata = this.agreementContent[name]
      this.content = newdata
    },
    //获取角色协议列表
    getData() {
      var url = "/addons/litestore/api.account/getUserAgreement"
      //这里直接调用网络接口
      let params = {
        place: '980'
      }
      util.get(url, params, res => {
        if (res.code == 1) {
          let addobj = {};
          //let newdata = res.data.concat(this.demo);
          res.data.forEach((x, i) => {
            addobj = {
              name: i,
              title: x.title
            }
            x.name = i
            this.tabs.push(addobj)
          })
          this.agreementContent = res.data
          let data = res.data[0];
          this.content = data;
        }
      })
    },
  }
}
</script>
<style type="text/css" lang="less">
.agreement-box {
  padding: 15px 15px 30px;
  min-height: 300px;
}
</style>
